export default __webpack_public_path__ + "static/low-code-innovation-4e189cff48bac1ba10b827f767c2733a.svg";